import { Stack } from '@/features/uiKit/Stack';
import { Text } from '@/features/uiKit/Text';
import React from 'react';
import { FaqItem, FaqItemInfo } from './FaqItem';
import { landingContentFrame } from '../landingSettings';

interface GeneralFaqBlockProps {
  items: FaqItemInfo[];
  title: string;
  subTitle: string;
  padding?: string;
  id?: string;
}
export const GeneralFaqBlock = ({ items, title, subTitle, padding, id }: GeneralFaqBlockProps) => {
  return (
    <Stack
      id={id}
      sx={{
        width: '100%',
        padding: padding || '120px 0 100px 0',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '100px',
        backgroundColor: '#fff',
        color: '#111',
        position: 'relative',
        zIndex: 1,
        overflow: 'hidden',
        '& details': {
          backgroundColor: '#fff',
          backgroundImage: 'none',
          color: '#111',
          boxShadow: 'none',
          borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
        },
      }}
    >
      <Stack
        sx={{
          ...landingContentFrame,
          alignItems: 'flex-start',
        }}
      >
        <Stack
          sx={{
            width: '100%',
            maxWidth: '700px',
            gap: '50px',
            alignItems: 'stretch',
          }}
        >
          <Stack>
            <Text as="h2" variant="title" align="left">
              {title}
            </Text>
            <Text variant="title" color="secondary" align="left">
              {subTitle}
            </Text>
          </Stack>

          <Stack
            sx={{
              flexDirection: 'column',
              gap: '0px',
              alignItems: 'stretch',
              width: '100%',
            }}
          >
            {items.map((item, index) => (
              <FaqItem key={index} info={item} />
            ))}
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};
